import React from "react";
import useSpotlight from "../../hooks/useSpotlight";

/**
 * Cartão cujo brilho interno e borda acompanham o cursor.
 * `spot` / `line` aceitam qualquer cor rgba.
 */
const SpotlightCard = ({
  spot = "rgba(0,178,169,.16)",
  line = "rgba(0,178,169,.7)",
  className = "",
  style,
  children,
  ...rest
}) => {
  const { ref, onMouseMove } = useSpotlight();

  return (
    <div
      ref={ref}
      onMouseMove={onMouseMove}
      className={`spotlight border-glow ${className}`}
      style={{ "--spot": spot, "--spot-line": line, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default SpotlightCard;
